import React, { useEffect, useMemo } from 'react';
import { actions as screeningActions } from '../../redux/screeningActions';
import getIncludedResponse from '../../../../helpers/getIncludedResource';
import { Button, ButtonBar } from '../../../../common/components';
import { connect, useSelector } from 'react-redux';
import ConditionQuestions from '../ConditionQuestions/ConditionQuestions';
import ConditionSearch from '../ConditionSearch/ConditionSearch';
import { FullRow } from '../../../layout/components';
import DeclaredConditions from '../DeclaredConditions/DeclaredConditions';
import { Alert } from 'react-bootstrap';
import './HealixSession.scss';

const getConditionsNeedRescreen = (allConditions) => {
  return Array.isArray(allConditions)
    ? allConditions.reduce((carry, condition) => {
        const conditionName = condition.attributes.conditions.join(', ');
        if (
          condition.attributes.requiresFullRescreen ||
          condition.attributes.requiresPartialRescreen
        ) {
          carry = (carry ? ' ' : '') + conditionName;
        }
        return carry;
      }, '')
    : '';
};

const HealixSession = ({
  onFinishScreening,
  onCancelDeclaration,
  onFinishDeclaration,
  onReset,
  travellerIndex,
}) => {
  const {
    declaration,
    declaredConditions,
    index,
    complete,
    isSubmitting,
    isCancelling,
    screeningError,
  } = useSelector((state) => state.screening);

  const includedConditions = getIncludedResponse(
    declaration.data,
    declaration.included,
    'conditions',
  );

  useEffect(() => {
    return () => {
      onReset();
    };
  }, []);
  const conditions = Array.isArray(includedConditions) ? includedConditions : [];

  const allConditions = getIncludedResponse(
    declaredConditions.data,
    declaredConditions.included,
    'conditions',
  );

  const conditionsThatNeedRescreen = useMemo(
    () => getConditionsNeedRescreen(allConditions),
    [allConditions],
  );
  return (
    <div className="screening-session-healix">
      {conditions.map((condition, i) => {
        return (
          <ConditionQuestions key={i} condition={condition} declaration={declaration} />
        );
      })}

      <ConditionSearch show={!conditions.length} index={index} />

      {!!screeningError && (
        <Alert bsStyle="danger">
          There was is a issue with your screening, please review the following questions
          <ul>
            <li> {screeningError} </li>
          </ul>
        </Alert>
      )}
      <FullRow>
        <ButtonBar>
          <div className="declaration-actions">
            {!complete && declaration?.data?.attributes?.state === 'ready' && (
              <Button
                bsStyle="primary"
                isLoading={isSubmitting}
                label="Continue"
                className="pull-right"
                handleClick={onFinishDeclaration}
              />
            )}
            {!!conditions.length && (
              <Button
                bsStyle="default"
                disabled={isSubmitting || isCancelling}
                isLoading={isCancelling}
                label="Cancel Screening"
                className="pull-right"
                handleClick={onCancelDeclaration}
              />
            )}
          </div>
        </ButtonBar>
      </FullRow>
      <FullRow>
        {!!conditionsThatNeedRescreen && (
          <span className={'screening-warning-msg'}>
            Warning: {conditionsThatNeedRescreen} needs re-screening
          </span>
        )}
      </FullRow>
      {complete && (
        <>
          <DeclaredConditions />
          <FullRow>
            <div className="declaration-actions">
              <Button
                className="pull-right"
                bsStyle="primary"
                label="Finish Screening"
                disabled={!!conditionsThatNeedRescreen}
                isLoading={isSubmitting && travellerIndex === index}
                handleClick={onFinishScreening}
              />
            </div>
          </FullRow>
        </>
      )}
    </div>
  );
};

export default connect(
  null,
  {
    onFinishDeclaration: screeningActions.finishDeclaration,
    onCancelDeclaration: screeningActions.cancelDeclaration,
    onReset: screeningActions.reset,
  },
)(HealixSession);
